import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

/** Колонки таблицы ГИБДД, по которым возможна клиентская сортировка */
export const GIBDD_SORTABLE_COLUMNS = [
  "id",
  "vin",
  "dateRegistration",
  "city",
  "district",
  "region",
  "federalArea",
  "createdAt",
  "updatedAt",
];

const localeCompare = (a: unknown, b: unknown) =>
  String(a ?? "").localeCompare(String(b ?? ""));

const compareRawDate = (rawKey: string) => (a: any, b: any) =>
  (a[rawKey] ?? 0) - (b[rawKey] ?? 0);

const COMPARATORS: Record<string, (a: any, b: any) => number> = {
  id: (a, b) => localeCompare(a.id, b.id),
  vin: (a, b) => localeCompare(a.vin, b.vin),
  // Даты сортируются по timestamp из raw-полей (в dataIndex лежит
  // отформатированная строка dd.MM.yyyy, она для сортировки не подходит)
  dateRegistration: compareRawDate("dateRegistrationRaw"),
  city: (a, b) => localeCompare(a.city, b.city),
  district: (a, b) => localeCompare(a.district, b.district),
  region: (a, b) => localeCompare(a.region, b.region),
  federalArea: (a, b) => localeCompare(a.federalArea, b.federalArea),
  createdAt: compareRawDate("createdAtRaw"),
  updatedAt: compareRawDate("updatedAtRaw"),
};

export const getGibddColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
): ColumnsType<any> =>
  options.map((option) => {
    const comparator = COMPARATORS[option];
    const sortOrder: SortOrder | undefined =
      comparator &&
      sortField === option &&
      (sortType === "ASC" || sortType === "DESC")
        ? sortType === "DESC"
          ? "descend"
          : "ascend"
        : undefined;

    return {
      title: t(`gibdd.${option}`),
      dataIndex: option,
      key: option,
      ...(comparator ? { sorter: comparator, sortOrder } : {}),
      render: (value: any) => <span>{value}</span>,
    };
  });
